import {
  OrientationOf2dOverviewOptions,
  ViewObjectTypes,
  ViewOptionsState,
} from "./view-options-slice";

type State = {
  viewOptions: ViewOptionsState;
};

/**
 * @param type of object to check the visibility for
 * @returns if that type of objects should be visible
 */
export function selectObjectVisibility(type: ViewObjectTypes) {
  return ({ viewOptions }: State): boolean => viewOptions.visibility[type];
}

/** @returns the map of the objects visibilities */
export function selectObjectsVisibility({
  viewOptions,
}: State): Record<ViewObjectTypes, boolean> {
  return viewOptions.visibility;
}

/**
 * @returns the visibility distance of the project
 */
export function selectVisibilityDistance({ viewOptions }: State): number {
  return viewOptions.visibilityDistance;
}

/**
 * @returns how the 2D overview should be oriented: with the sheet orientation or the project orientation
 */
export function selectOrientationOf2dOverview({
  viewOptions,
}: State): OrientationOf2dOverviewOptions {
  return viewOptions.orientationOf2dOverview;
}

/**
 * @returns if the waypoints should be rendered on the floor or at the scan height
 */
export function selectShouldShowWaypointsOnFloors({
  viewOptions,
}: State): boolean {
  return viewOptions.shouldShowWaypointsOnFloors;
}

/**
 * @param state the root application state
 * @returns the viewOptions slice of the store
 */
export function selectViewOptionsSlice({
  viewOptions,
}: State): ViewOptionsState {
  return viewOptions;
}

/**
 * @param state the root application state
 * @returns the minimum spacing in meters between generated odometry waypoints
 */
export function selectOdometryWaypointSpacing({ viewOptions }: State): number {
  return viewOptions.odometryWaypointSpacing;
}

/** @returns true if the dynamic overview map should be rendered in place of the static one */
export function selectShowDynamicOverviewMap({ viewOptions }: State): boolean {
  return viewOptions.showDynamicOverviewMap;
}
